import { LogErrors } from './../../LogErrors'

import { GetResults as DLGetResults } from './../../DL/Student/Results'
import { UpdateSessionInfo } from './../Sessions'


const GetResults = async (session) => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))

        const idCenter = userData?.navigation?.center?.id
        if (!idCenter) {
          return { success: false, message: '' }
        }
        
        const response = await DLGetResults(session.token, idCenter)
        
        if (response.success) {
            // Guardar info de evaluaciones en info de sesión
            if (response.data.evaluations !== undefined && response.data.evaluations !== null) {
                if (response.data.evaluations.length > 0) {
                    userData.evaluations = response.data.evaluations
        
                    await UpdateSessionInfo(userData)
                }
            }
            
            return { success: true, data: userData } //response.data
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetResults BL Results', error)
        return { success: false, message: '' }
    }
}

const GetItemResult = async (session) => {
    try {
        const evaluations = session?.evaluations
        if (!evaluations) {
          return { success: false, message: '' }
        }

        const idCourse = session?.navigation?.result?.course
        if (!idCourse) {
          return { success: false, message: '' }
        }

        const indexEvaluation = session?.navigation?.result?.item
        if (indexEvaluation === undefined || indexEvaluation === null) {
          return { success: false, message: '' }
        }
        
        const filteredEvaluations = evaluations.filter(evaluation => evaluation.idCourse === idCourse)
        
        const evaluation = filteredEvaluations[indexEvaluation]
        
        if (evaluation) {
            return { success: true, data: evaluation }
        } else {
            return { success: false, message: '' }
        }
    } catch (error) {
        await LogErrors('GetItemResult BL Results', error)
        return { success: false, message: '' }
    }
}

const GetDataFromTheChosenCourse = async (session, idCourse) => {
  try {
    if (session.user.courses === undefined || session.user.courses === null) {
      return { success: false, data: '' }
    }

    //Comprobar varias propiedades para ver si está correcta la info del usuario
    if (session.user.courses.myCourses === undefined || session.user.courses.myCourses === null) {
      return { success: false, data: '' }
    }

    if (session.user.courses.myCourses.length === 0) {
      return { success: false, data: '' }
    }

    const course = session.user.courses.myCourses.find(myCourse => myCourse.id === idCourse)
    
    if (!course) {
      return { success: true, data: '' }
    }

    return { success: true, data: course }
  } catch (error) {
    await LogErrors('GetDataFromTheChosenCourse BL Results', error)
    return { success: false, message: '' }
  }
}

const SaveInstrumentToShowOfResultView = async (session, result, task) => {
  try {
    const responseData = await GetDataFromTheChosenCourse(session, result.idCourse)
    
    if (!responseData.success) {
      return { success: false, message: 'No ha sido posible mostrar el instrumento de aprendizaje solicitado. Inténtalo nuevamente o inténtalo más tarde.' }
    }
    
    const course = {
        id: responseData?.data?.id,
        name: responseData?.data?.name,
        type: responseData?.data?.type,
        level: responseData?.data?.level,
        goToQuickAccessInstrument: false
    }
    
    const instrument = {
        id: task?.itemId,
        name: task?.itemName,
        type: 2, //Instrumento de aprendizaje
        exam: 'Examen: ' + result.name,
        enabled: true // Temporal, pero debe ser dinámico
    }
    
    const navigation = session?.navigation
    
    if (!navigation) {
      return { success: false, message: 'No ha sido posible mostrar el instrumento de aprendizaje solicitado. Inténtalo nuevamente o inténtalo más tarde.' }
    }
    
    session.navigation.course = course
    session.navigation.instrument = instrument
    session.navigation.backToResultsView = true
    
    const newSession = await GetBadAnsweredQuestions(session, result)
    
    const response = await UpdateSessionInfo(newSession)
      
    if (response.success) {
        return { success: true, data: null }
    } else {
        return { success: false, message: response.message }
    }
  } catch (error) {
    await LogErrors('SaveInstrumentToShowOfResultView - BL Results', error)
    return { success: false, message: '' }
  }
}

const GetBadAnsweredQuestions = async (session, result) => {
  try {
    let badAnswered = []
    let badAnsweredQuestions = null

    // Guardar listado de preguntas contestadas incorrectamente
    const questions = result?.questions

    if (questions) {
      if (questions.length > 0) {
        badAnsweredQuestions = questions.flatMap(question =>
          question.tasks.filter(task => task.result === 0)
        )
      }
    }

    if (badAnsweredQuestions) {
        if (badAnsweredQuestions.length === 0) {
          badAnswered = null
        } else {
            switch (badAnsweredQuestions.length) {
                case 0:
                  badAnswered = null
                  break

                case 1:
                  const taskData = {
                      id: badAnsweredQuestions[0].itemId,
                      name: badAnsweredQuestions[0].itemName,
                      type: 2 // Instrumento de aprendizaje
                  }
                  badAnswered.push(taskData)
                  break

                default:
                  badAnsweredQuestions.forEach(task => {
                      const taskData = {
                          id: task.itemId,
                          name: task.itemName,
                          type: 2 // Instrumento de aprendizaje
                      }
                      badAnswered.push(taskData)
                  })
                  break
            }
        }
    } else {
      badAnswered = null
    }

    session.badAnsweredQuestions = badAnswered

    return session
  } catch (error) {
    await LogErrors('GetBadAnsweredQuestions - BL Results', error)  
  }
}

const ResetItemsViewData = async (session) => {
  try {
    const backToResultsView = session?.navigation?.backToResultsView
    if (backToResultsView) {
        session.navigation.backToResultsView = false
    }

    const badAnsweredQuestions = session?.badAnsweredQuestions
    if (badAnsweredQuestions) {
        session.badAnsweredQuestions = null
    }

    const instrument = session?.navigation?.instrument
    if (instrument) {
        session.navigation.instrument = null
    }

    const response = await UpdateSessionInfo(session)

    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: '' }
    }
  } catch (error) {
    await LogErrors('ResetItemsViewData - BL Results', error)
    return { success: false, message: '' }
  }
}

export { GetResults, GetItemResult, GetDataFromTheChosenCourse, SaveInstrumentToShowOfResultView, ResetItemsViewData };